// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // console.log('Initializing bundle cross selling...');
  initializeBundleCrossSelling();
});

function initializeBundleCrossSelling() {
  const bundleContainers = document.querySelectorAll('.bundle-cross-selling');
  // console.log('Found bundle containers:', bundleContainers.length);
  
  bundleContainers.forEach(container => {
    new BundleCrossSelling(container);
  });
}

class BundleCrossSelling {
  constructor(element) {
    this.element = element;
    this.currentProductId = this.element.dataset.currentProductId;
    this.sectionId = this.element.dataset.sectionId;
    this.selectedProductId = null;
    // console.log('Bundle cross selling initialized for section:', this.sectionId);
    this.init();
  }

  init() {
    this.setupProductSelection();
    this.setupInitialVariantHandling();
  }

  setupProductSelection() {
    const productCards = this.element.querySelectorAll('.bundle-product-card');
    // console.log('Found product cards:', productCards.length);
    
    productCards.forEach((card, index) => {
      const productId = card.dataset.productId;
      const productHandle = card.dataset.productHandle;
      // console.log('Setting up card for product:', productId, 'handle:', productHandle);
      
      // Set first product as selected by default
      if (index === 0) {
        this.selectProduct(card, productId);
      }

      card.addEventListener('click', (e) => {
        // console.log('=== CARD CLICKED ===');
        // console.log('Product ID:', productId);
        // console.log('Product Handle:', productHandle);
        // console.log('Card element:', card);
        
        
        this.selectProduct(card, productId);
        
        // Simple test - update page title temporarily
        document.title = `Clicked: ${productHandle || productId}`;
        
        // Switch product data
        if (productHandle) {
          // console.log('Calling switchProductData with handle:', productHandle);
          this.switchProductData(productHandle);
        } else {
          // console.log('No product handle found, cannot switch product data');
        }
      });
    });
  }

  selectProduct(card, productId) {
    // console.log('Selecting product:', productId);
    // Remove selected state from all cards
    this.element.querySelectorAll('.bundle-product-card').forEach(c => {
      c.classList.remove('bundle-product-card--selected');
    });

    // Add selected state to clicked card
    card.classList.add('bundle-product-card--selected');
    this.selectedProductId = productId;

    // Dispatch custom event for product selection
    this.element.dispatchEvent(new CustomEvent('bundle:product-selected', {
      detail: { productId: productId },
      bubbles: true
    }));

    // console.log('Bundle product selected:', productId);
  }

  setupInitialVariantHandling() {    
    // Find the current product's variant picker
    const variantPickerBlock = document.querySelector('.product__block--variant_picker');
    if (!variantPickerBlock) {
      // console.log('No variant picker found for initial setup');
      return;
    }

    const variantSelects = variantPickerBlock.querySelector('variant-selects');
    if (!variantSelects) {
      // console.log('No variant-selects element found for initial setup');
      return;
    }

    // Get the current product data from the first bundle card (which is the current product)
    const currentProductCard = this.element.querySelector('.bundle-product-card--current');
    if (!currentProductCard) {
      // console.log('No current product card found for initial setup');
      return;
    }

    const currentProductHandle = currentProductCard.dataset.productHandle;
    if (!currentProductHandle) {
      // console.log('No current product handle found for initial setup');
      return;
    }

    // Fetch current product data and set up variant handling
    this.fetchProductData(currentProductHandle).then(productData => {
      if (productData) {
        // console.log('Setting up initial variant handling for:', productData.title);
        variantSelects._bundleProductData = productData;
        this.setupCustomVariantHandling(variantSelects, productData);
      }
    });
  }


      async switchProductData(productHandle) {
        // console.log('Switching to product handle:', productHandle);
        
        try {
          // Show loading state
          this.showLoadingState();
          
          // Fetch product data
          const productData = await this.fetchProductData(productHandle);
          
          if (productData) {
            // Update buy box with new product data
            this.updateBuyBox(productData);
            // console.log('Product data switched successfully to:', productData.title);
          }
          
        } catch (error) {
          console.error('Error switching product data:', error);
        } finally {
          // Hide loading state
          this.hideLoadingState();
        }
      }

      async fetchProductData(productHandle) {
        try {
          // console.log('Fetching product data for handle:', productHandle);
          const response = await fetch(`/products/${productHandle}.js`);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          // console.log('Fetched product data:', data.title);
          return data;
        } catch (error) {
          console.error('Error fetching product data:', error);
          return null;
        }
      }

      updateBuyBox(productData) {
        // console.log('Updating buy box with:', productData.title);
        
        // Update price
        this.updatePrice(productData);
        
        // Update product title
        this.updateTitle(productData);
        
        // Update description
        this.updateDescription(productData);
        
        // Update variant picker
        this.updateVariantPicker(productData);
        
        // Update add to cart form
        this.updateAddToCartForm(productData);
        
        // Update inventory information
        this.updateInventory(productData);
        
        // Update SKU
        this.updateSKU(productData);
      }

      updatePrice(productData) {
        const priceElement = document.querySelector('#price-' + this.sectionId);
        if (priceElement && productData.price) {
          const formattedPrice = this.formatPrice(productData.price);
          const priceHTML = `
            <div class="f-price f-price--large">
              <div class="price__container">
                <div class="price__regular">
                  <span class="visually-hidden">Regular price</span>
                  <span class="price-item price-item--regular">${formattedPrice}</span>
                </div>
              </div>
            </div>
          `;
          priceElement.innerHTML = priceHTML;
          // console.log('Price updated to:', formattedPrice);
        }
      }

      updateTitle(productData) {
        const titleElements = document.querySelectorAll('.product__title');
        titleElements.forEach(titleElement => {
          if (titleElement) {
            const titleLink = titleElement.querySelector('a');
            if (titleLink) {
              titleLink.textContent = productData.title;
              titleLink.href = `/products/${productData.handle}`;
            } else {
              titleElement.textContent = productData.title;
            }
          }
        });
        // console.log('Title updated to:', productData.title);
      }

      updateDescription(productData) {
        // console.log('Updating description for:', productData.title);
        
        // Try multiple selectors to find the description element
        const descriptionSelectors = [
          '.product__block--description .rte',
          '.product__block--description',
          '[data-block-type="description"]',
          '.product__description'
        ];
        
        let descriptionElement = null;
        for (const selector of descriptionSelectors) {
          descriptionElement = document.querySelector(selector);
          if (descriptionElement) {
            // console.log('Found description element with selector:', selector);
            break;
          }
        }
        
        if (descriptionElement && productData.description) {
          // If it has an .rte child, update that, otherwise update the element directly
          const rteElement = descriptionElement.querySelector('.rte');
          const targetElement = rteElement || descriptionElement;
          
          targetElement.innerHTML = productData.description;
          // console.log('Description updated successfully');
          // console.log('New description:', productData.description.substring(0, 100) + '...');
        } else {
          // console.log('Description element not found or no description data');
          // console.log('Available description:', productData.description ? 'Yes' : 'No');
        }
      }

      async updateVariantPicker(productData) {
        // console.log('Updating variant picker for:', productData.title);
        // console.log('Product has', productData.variants.length, 'variants');
        
        const variantPickerBlock = document.querySelector('.product__block--variant_picker');
        if (!variantPickerBlock) {
          // console.log('Variant picker block not found');
          return;
        }

        try {
          // If product has only one variant, hide the variant picker
          if (productData.variants.length <= 1) {
            variantPickerBlock.style.display = 'none';
            // console.log('Product has only one variant, hiding variant picker');
            return;
          }

          // Show variant picker if it was hidden
          variantPickerBlock.style.display = '';
          // console.log('Product has multiple variants, showing variant picker');

          // Show loading state for variant picker
          this.showVariantPickerLoading(variantPickerBlock);

          // Fetch the complete product page to get the variant picker
          const response = await fetch(`/products/${productData.handle}`);
          const responseText = await response.text();
          
          // Parse the response to extract variant picker content
          const parser = new DOMParser();
          const doc = parser.parseFromString(responseText, 'text/html');
          const newVariantBlock = doc.querySelector('.product__block--variant_picker');
          
          if (newVariantBlock) {
            // Replace the entire variant picker block content
            variantPickerBlock.innerHTML = newVariantBlock.innerHTML;
            
            // console.log('Variant picker HTML updated successfully');
            
            // Find and reinitialize the variant-selects element
            const newVariantSelects = variantPickerBlock.querySelector('variant-selects');
            if (newVariantSelects) {
              // console.log('Reinitializing variant-selects element');
              
              // Update the data-url to point to the new product
              newVariantSelects.setAttribute('data-url', `/products/${productData.handle}`);
              // console.log('Updated variant-selects data-url to:', `/products/${productData.handle}`);
              
              // Store reference to current product data for variant changes
              newVariantSelects._bundleProductData = productData;
              
              // Override the variant change handling to prevent reverting to main product
              this.setupCustomVariantHandling(newVariantSelects, productData);
              
              // console.log('Custom variant handling setup complete');
            }
            
            // Hide loading state
            this.hideVariantPickerLoading(variantPickerBlock);
            
            // Update the first variant as selected
            this.updateAddToCartForm(productData);
          } else {
            // console.log('Could not find variant picker block in response');
          }
          
        } catch (error) {
          console.error('Error updating variant picker:', error);
        }
      }

      setupCustomVariantHandling(variantSelectsElement, productData) {
        // console.log('Setting up custom variant handling for:', productData.title);
        
        // Find all variant option inputs (radio buttons, selects, etc.)
        const variantInputs = variantSelectsElement.querySelectorAll('input[type="radio"], select');
        // console.log('Found variant inputs:', variantInputs.length);
        
        variantInputs.forEach(input => {
          input.addEventListener('change', (e) => {
            // console.log('Variant option changed:', e.target.value);
            
            // Prevent the default theme behavior and handle it ourselves
            e.stopPropagation();
            
            // Get all selected options
            const selectedOptions = this.getSelectedVariantOptions(variantSelectsElement);
            // console.log('Selected options:', selectedOptions);
            
            // Find the matching variant
            const selectedVariant = this.findVariantByAllOptions(productData, selectedOptions);
            
            if (selectedVariant) {
              // console.log('Found matching variant:', selectedVariant.title, 'ID:', selectedVariant.id);
              
              // Update buy box with the selected variant
              this.updateBuyBoxWithSpecificVariant(productData, selectedVariant);
              
              // Update the variant data in the element
              const variantDataScript = variantSelectsElement.querySelector('[data-selected-variant]');
              if (variantDataScript) {
                variantDataScript.textContent = JSON.stringify(selectedVariant);
              }
            } else {
              // console.log('No matching variant found for options:', selectedOptions);
            }
          });
        });
      }

      getSelectedVariantOptions(variantSelectsElement) {
        const options = [];
        const fieldsets = variantSelectsElement.querySelectorAll('fieldset');
        
        fieldsets.forEach(fieldset => {
          // Check for radio buttons
          const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
          if (checkedRadio) {
            options.push(checkedRadio.value);
            return;
          }
          
          // Check for select dropdowns
          const select = fieldset.querySelector('select');
          if (select) {
            options.push(select.value);
          }
        });
        
        return options;
      }

      findVariantByAllOptions(productData, selectedOptions) {
        return productData.variants.find(variant => {
          return selectedOptions.every((option, index) => {
            return variant.options[index] === option;
          });
        });
      }

      updateBuyBoxWithSpecificVariant(productData, variant) {
        // console.log('Updating buy box with specific variant:', variant.title);
        
        // Update price with variant price
        this.updatePriceWithVariant(variant);
        
        // Update variant name
        this.updateVariantName(variant);
        
        // Update bundle card price
        this.updateBundleCardPrice(productData, variant);
        
        // Update add to cart form with specific variant
        this.updateAddToCartFormWithVariant(variant);
        
        // Update inventory for specific variant
        this.updateInventoryWithVariant(variant);
        
        // Update SKU for specific variant
        this.updateSKUWithVariant(variant);
      }

      updatePriceWithVariant(variant) {
        const priceElement = document.querySelector('#price-' + this.sectionId);
        if (priceElement && variant.price) {
          const formattedPrice = this.formatPrice(variant.price);
          
          // Try multiple selectors to find the price element
          const priceSelectors = [
            '.f-price-item--regular',
            '.price-item--regular',
            '.f-price-item',
            '.price-item',
            '.price__regular .price-item',
            '.price__regular'
          ];
          
          let priceItem = null;
          for (const selector of priceSelectors) {
            priceItem = priceElement.querySelector(selector);
            if (priceItem) {
              // console.log('Found price element with selector:', selector);
              break;
            }
          }
          
          if (priceItem) {
            priceItem.textContent = formattedPrice;
            // console.log('Main price updated to:', formattedPrice);
          } else {
            // If no specific price element found, try to update the entire price container
            // console.log('No specific price element found, updating entire price container');
            const priceHTML = `
              <div class="f-price f-price--large">
                <div class="price__container">
                  <div class="price__regular">
                    <span class="visually-hidden">Regular price</span>
                    <span class="price-item price-item--regular">${formattedPrice}</span>
                  </div>
                </div>
              </div>
            `;
            priceElement.innerHTML = priceHTML;
            // console.log('Main price container updated to:', formattedPrice);
          }
        }
      }

      updateBundleCardPrice(productData, variant) {
        // console.log('Updating bundle card price for product:', productData.title, 'variant:', variant.title);
        
        // Find the bundle card for this product
        const bundleCard = this.element.querySelector(`[data-product-id="${productData.id}"]`);
        if (bundleCard) {
          const priceElement = bundleCard.querySelector('.bundle-product-card__price');
          if (priceElement) {
            const formattedPrice = this.formatPrice(variant.price);
            
            // Update the price text content
            const priceText = priceElement.querySelector('.f-price-item--regular');
            if (priceText) {
              priceText.textContent = formattedPrice;
            } else {
              // If no price structure exists, create a simple one
              priceElement.innerHTML = `<span class="f-price-item f-price-item--regular">${formattedPrice}</span>`;
            }
            
            // console.log('Bundle card price updated to:', formattedPrice);
          }
        }
      }

      updateVariantName(variant) {
        // console.log('Updating variant name to:', variant.title);
        
        // Look for the specific span with data-selected-swatch-value attribute
        const variantNameElement = document.querySelector('span[data-selected-swatch-value]');
        
        if (variantNameElement) {
          variantNameElement.textContent = variant.title;
          variantNameElement.setAttribute('data-selected-swatch-value', variant.title);
          // console.log('Variant name updated to:', variant.title);
        } else {
          // console.log('Variant name element not found');
        }
      }

      updateAddToCartFormWithVariant(variant) {
        const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
        addToCartForms.forEach(form => {
          const variantInput = form.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = variant.id;
            // console.log('Add to cart form updated with variant:', variant.id);
          }
        });
      }

      updateInventoryWithVariant(variant) {
        const inventoryElement = document.querySelector('#Inventory-' + this.sectionId);
        if (inventoryElement) {
          const inventoryText = inventoryElement.querySelector('.product__inventory-text');
          if (inventoryText) {
            if (variant.available) {
              inventoryText.textContent = 'In stock';
              inventoryElement.classList.remove('invisible');
            } else {
              inventoryText.textContent = 'Out of stock';
            }
          }
          // console.log('Variant inventory updated:', variant.available ? 'In stock' : 'Out of stock');
        }
      }

      updateSKUWithVariant(variant) {
        const skuElement = document.querySelector('#Sku-' + this.sectionId);
        if (skuElement) {
          if (variant.sku) {
            skuElement.textContent = variant.sku;
            skuElement.classList.remove('invisible');
          } else {
            skuElement.classList.add('invisible');
          }
          // console.log('Variant SKU updated to:', variant.sku || 'none');
        }
      }

      updateAddToCartForm(productData) {
        const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
        addToCartForms.forEach(form => {
          const variantInput = form.querySelector('input[name="id"]');
          if (variantInput && productData.variants && productData.variants.length > 0) {
            variantInput.value = productData.variants[0].id;
            // console.log('Add to cart form updated with variant:', productData.variants[0].id);
          }
        });
      }

      updateInventory(productData) {
        const inventoryElement = document.querySelector('#Inventory-' + this.sectionId);
        if (inventoryElement && productData.variants && productData.variants.length > 0) {
          const variant = productData.variants[0];
          const inventoryText = inventoryElement.querySelector('.product__inventory-text');
          if (inventoryText) {
            if (variant.available) {
              inventoryText.textContent = 'In stock';
              inventoryElement.classList.remove('invisible');
            } else {
              inventoryText.textContent = 'Out of stock';
            }
          }
          // console.log('Inventory updated:', variant.available ? 'In stock' : 'Out of stock');
        }
      }

      updateSKU(productData) {
        const skuElement = document.querySelector('#Sku-' + this.sectionId);
        if (skuElement && productData.variants && productData.variants.length > 0) {
          const variant = productData.variants[0];
          if (variant.sku) {
            skuElement.textContent = variant.sku;
            skuElement.classList.remove('invisible');
          } else {
            skuElement.classList.add('invisible');
          }
          // console.log('SKU updated to:', variant.sku || 'none');
        }
      }

      formatPrice(priceInCents) {
        const price = priceInCents / 100;
        return `€${price.toFixed(2).replace('.', ',')} EUR`;
      }

      showLoadingState() {
        const buyBox = document.querySelector('.product__info-wrapper');
        if (buyBox) {
          buyBox.style.opacity = '0.6';
          buyBox.style.transition = 'opacity 0.3s ease';
          // console.log('Loading state shown');
        }
      }

      hideLoadingState() {
        const buyBox = document.querySelector('.product__info-wrapper');
        if (buyBox) {
          buyBox.style.opacity = '';
          buyBox.style.transition = '';
          // console.log('Loading state hidden');
        }
      }

      showVariantPickerLoading(variantPickerBlock) {
        // Disable all existing variant inputs
        const existingInputs = variantPickerBlock.querySelectorAll('input, select, button');
        existingInputs.forEach(input => {
          input.disabled = true;
          input.style.opacity = '0.5';
        });

        // Add loading overlay
        const loadingOverlay = document.createElement('div');
        loadingOverlay.className = 'variant-picker-loading-overlay';
        loadingOverlay.innerHTML = `
          <div class="variant-picker-loading-content">
            <div class="variant-picker-spinner"></div>
            <span>Loading variants...</span>
          </div>
        `;
        loadingOverlay.style.cssText = `
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
          border-radius: 8px;
        `;

        // Make the variant picker block relative for positioning
        variantPickerBlock.style.position = 'relative';
        variantPickerBlock.appendChild(loadingOverlay);

        // console.log('Variant picker loading state shown');
      }

      hideVariantPickerLoading(variantPickerBlock) {
        // Remove loading overlay
        const loadingOverlay = variantPickerBlock.querySelector('.variant-picker-loading-overlay');
        if (loadingOverlay) {
          loadingOverlay.remove();
        }

        // Re-enable all inputs
        const inputs = variantPickerBlock.querySelectorAll('input, select, button');
        inputs.forEach(input => {
          input.disabled = false;
          input.style.opacity = '';
        });

        // Reset position
        variantPickerBlock.style.position = '';

        // console.log('Variant picker loading state hidden');
      }
}